
import useScrollAnimation from '../../../hooks/useScrollAnimation';

const ProcesoSection = () => {
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation({ threshold: 0.2 });

  const pasos = [
    {
      numero: '01',
      titulo: 'Contacta con Nosotros',
      descripcion: 'Llámanos o escríbenos por WhatsApp. Te atendemos de inmediato y te pedimos información básica sobre tu vehículo en Gavá.',
      icon: 'ri-phone-fill',
    },
    {
      numero: '02',
      titulo: 'Valoración Gratuita',
      descripcion: 'Te damos un presupuesto sin compromiso en menos de 2 horas. Valoración justa y transparente basada en el estado real del coche.',
      icon: 'ri-price-tag-3-fill',
    },
    {
      numero: '03',
      titulo: 'Recogida del Vehículo',
      descripcion: 'Acordamos día y hora para recoger tu coche en Gavá o alrededores. Servicio de grúa incluido sin coste adicional.',
      icon: 'ri-truck-fill',
    },
    {
      numero: '04',
      titulo: 'Pago Inmediato',
      descripcion: 'Recibes el dinero al momento de la recogida. Pago en efectivo o transferencia bancaria instantánea. Sin esperas.',
      icon: 'ri-money-euro-circle-fill',
    },
  ];

  return (
    <section className="py-24 px-6 lg:px-12 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div
          ref={headerRef}
          className={`text-center mb-16 transition-all duration-700 ${
            headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Cómo Funciona Nuestro Desguace en Gavá
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Vender tu coche siniestrado o averiado en Gavá es rápido y sencillo. Solo 4 pasos y tendrás el dinero en tu cuenta
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {pasos.map((paso, index) => (
            <PasoCard key={index} paso={paso} index={index} total={pasos.length} />
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="tel:932932913"
            className="inline-flex items-center space-x-3 bg-emerald-600 hover:bg-emerald-700 text-white px-10 py-4 rounded-lg font-bold text-lg transition-all hover:scale-105 shadow-xl whitespace-nowrap"
          >
            <i className="ri-phone-fill text-xl"></i>
            <span>Empezar Ahora</span>
          </a>
        </div>
      </div>
    </section>
  );
};

const PasoCard = ({ paso, index, total }: { paso: { numero: string; titulo: string; descripcion: string; icon: string }; index: number; total: number }) => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.15 });

  return (
    <div ref={ref} className="relative">
      <div
        className={`bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all hover:-translate-y-2 h-full duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
        }`}
        style={{ transitionDelay: `${index * 150}ms` }}
      >
        <div className="text-6xl font-bold text-emerald-100 mb-4">{paso.numero}</div>
        <div className="w-14 h-14 bg-emerald-600 rounded-full flex items-center justify-center mb-6">
          <i className={`${paso.icon} text-white text-2xl`}></i>
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-3">
          <strong>{paso.titulo}</strong>
        </h3>
        <p className="text-gray-600 leading-relaxed">{paso.descripcion}</p>
      </div>
      {index < total - 1 && (
        <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
          <i className="ri-arrow-right-line text-3xl text-emerald-600"></i>
        </div>
      )}
    </div>
  );
};

export default ProcesoSection;
